import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import useNavModel from "../model/navModel";
import useGlobalModel from "../model/globalModel";
import { forFind } from "../utils/utils";
import menuData from "../data/menuData.json";
import { Layout, Spin } from "antd";
import AppMenu from "./AppMenu";
import AppHeader from "./AppHeader";
import AppNav from "./AppNav";
import AppRoute from "./AppRoute";
import { useDictModel } from "@/views/dict/dictModel";

const { Sider, Content } = Layout;

const Index = () => {

    const history = useHistory();
    const { user, cm, loadingInfo: { loadingVisible, txt }, setLoadingInfo, loadRestaurantAll } = useGlobalModel();
    const { loadData: loadDictAll } = useDictModel()
    const { addNav } = useNavModel();
    useEffect(() => {
        // loadRestaurantAll()
        loadDictAll()
    }, [])
    //监听在地址栏输入url。
    useEffect(() => {
        history.listen((location, action) => {
            //每次切换页面 关闭全局loading
            setLoadingInfo({ loadingVisible: false, txt: "" });

            if (action === "POP" && location.pathname !== "/login" && user.token) {
                let findNav = forFind(menuData, location.pathname, "path", true);
                // console.log(location, action, "监听路有变化", findNav)
                addNav(findNav ? findNav.id : "404");
            }
        });
    }, []);

    return (
        <Layout style={{ height: "100vh" }}>
            <AppHeader />
            <Layout>
                <Sider className="layout-sider" trigger={null} collapsible collapsed={cm.collapsed} width={226} collapsedWidth={80}>
                    <div className="layout-sider-shop">{user.canteenName}</div>
                    <AppMenu />
                </Sider>
                <Layout className="layout-section">
                    <AppNav />
                    <Spin tip={txt} spinning={loadingVisible}>
                        <Content>
                            <div className="layout-section-content">
                                <AppRoute />
                            </div>
                        </Content>
                    </Spin>
                </Layout>
            </Layout>
        </Layout>
    )
}

export default Index;